import { useEffect } from 'react';
import { DrawingRoomProvider, useDrawingRoom } from '../contexts/DrawingRoomContext';
import CollaborativeExcalidraw from './CollaborativeExcalidraw';

const TEST_BOARD_ID = 'test-realtime';

function RealtimeTestBoardInner() {
  const { joinRoom } = useDrawingRoom();

  useEffect(() => {
    const tempUserId = `user-${Math.random().toString(36).substr(2, 9)}`;
    const userName = `TestUser-${Math.floor(Math.random() * 1000)}`;
    joinRoom(TEST_BOARD_ID, tempUserId, userName).catch(console.error);
  }, [joinRoom]);

  return (
    <div style={{
      height: '100vh',
      width: '100vw',
      background: '#f8f9fa',
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'stretch',
    }}>
      <CollaborativeExcalidraw />
    </div>
  );
}

export default function RealtimeTestBoard() {
  return (
    <DrawingRoomProvider>
      <RealtimeTestBoardInner />
    </DrawingRoomProvider>
  );
} 